import { enhanceCopyPaste } from 'pmn/enhancements/clipboardLink';
import { appViews } from './appViews';
import { loadView, resolveViewName } from './loader';
import { View } from './types';

export const setupAppView = (): View | void => {
  const viewName = resolveViewName();
  if (!viewName) {
    return;
  }

  // Get the current view name
  // Load view class and mount it
  const ViewClass = loadView(appViews, viewName);
  const currentView = new ViewClass();
  currentView.mount();

  enhanceCopyPaste(viewName);

  return currentView;
};
